import styled from 'styled-components';

export const ProgressWrapper = styled.div`
  padding: 25vh 0;
`;
